<riv-icon *ngIf="icon" [name]="icon" [size]="16"></riv-icon>
<ng-content></ng-content>
<riv-icon
  class="locked-icon"
  [name]="'Lock'"
  [size]="16"
  *ngIf="locked && showLockedIcon"
></riv-icon>
